export default __webpack_public_path__ + "static/media/battery-working.f5eae56e.svg";